import axios from "axios";

// You can set the API base URL in your environment variables
// NOTE: Direct import.meta.env reference is required for Vite static substitution
// during build. This ensures the URL is hardcoded into the bundle for verification.

const normalizeNoTrailingSlash = (value: string) => value.replace(/\/$/, "");
const DEFAULT_API_BASE_URL = "http://localhost:3000/v1";

// Direct reference to import.meta.env.VITE_API_BASE_URL allows Vite to statically
// substitute the environment variable during build, resulting in a hardcoded string
// in the compiled bundle that can be verified by grep checks in deployment workflows.
const configuredBase = (() => {
  try {
    return import.meta.env.VITE_API_BASE_URL?.trim();
  } catch {
    return undefined;
  }
})();

export const API_BASE_URL = configuredBase
  ? normalizeNoTrailingSlash(configuredBase)
  : DEFAULT_API_BASE_URL;

export const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 15_000,
  headers: {
    "Content-Type": "application/json",
  },
});

// NOTE: The 401 response interceptor is registered by setupAuthInterceptor()
// in authInterceptor.ts (called from main.tsx). Do NOT add an inline interceptor
// here — having two 401 interceptors on the same client causes refresh races,
// double redirects, and infinite /login ↔ /me loops.
